// Build a compact business-profile context string from the stored data.
// This is the SINGLE SOURCE OF TRUTH handed to the AI (Command, Content Studio,
// Event Lab) so every answer is personalized to the merchant's métier, diagnostic,
// actions already taken and available CRM data — without re-asking or inventing.
import { SUB_LABELS } from "./demoData";

export function buildProfileContext(data) {
  const o = data?.onboarding;
  if (!o) return "";
  const parts = [];
  if (o.business_name) parts.push(`Nom: ${o.business_name}`);
  if (o.activity_type) parts.push(`Secteur: ${o.activity_type}`);
  if (o.custom_activity) parts.push(`Activité précise: ${o.custom_activity}`);
  const loc = [o.city, o.country].filter(Boolean).join(", ");
  if (loc) parts.push(`Lieu: ${loc}`);
  if (o.company_size) parts.push(`Taille: ${o.company_size}`);
  if (o.main_goal) parts.push(`Objectif principal: ${o.main_goal}`);
  const presence = [o.facebook && "Facebook", o.instagram && "Instagram", o.google && "Google", o.website && "Site web", o.whatsapp && "WhatsApp Business", o.tiktok && "TikTok", o.email_marketing && "Email", o.sms_marketing && "SMS"].filter(Boolean).join(", ");
  if (presence) parts.push(`Présence: ${presence}`);
  if (o.loyalty_program) parts.push("Programme de fidélité: oui");
  if (o.promo_frequency) parts.push(`Fréquence promotions: ${o.promo_frequency}`);
  if (o.events_frequency) parts.push(`Fréquence animations: ${o.events_frequency}`);
  if (o.posting_frequency) parts.push(`Fréquence publications: ${o.posting_frequency}`);

  // Diagnostic: overall score + the two weakest axes (where to focus).
  const s = data?.scores;
  if (s?.global != null) parts.push(`Business Score: ${s.global}/100`);
  if (s?.subs) {
    const weak = Object.entries(s.subs).sort((a, b) => a[1] - b[1]).slice(0, 2)
      .map(([k, v]) => `${SUB_LABELS[k] || k} (${v})`).join(", ");
    if (weak) parts.push(`Axes à renforcer: ${weak}`);
  }

  // Actions already taken / in progress (avoid re-suggesting them).
  const done = (data?.actions || []).filter((a) => a.done).map((a) => a.title).slice(0, 3);
  if (done.length) parts.push(`Actions déjà réalisées: ${done.join(" ; ")}`);
  const progress = (data?.actions || []).filter((a) => a.status === "progress" && !a.done).map((a) => a.title).slice(0, 3);
  if (progress.length) parts.push(`Actions en cours: ${progress.join(" ; ")}`);

  // Available CRM / customer base (only what's really present).
  const l = data?.loyalty;
  if (l?.clients) parts.push(`Base clients: ${l.clients}${l.to_reactivate ? `, dont ${l.to_reactivate} à réactiver` : ""}`);

  // Optional commercial KPIs (only those actually provided — never invented).
  const kpi = [];
  if (o.revenue_monthly) kpi.push(`CA mensuel: ${o.revenue_monthly}€`);
  if (o.gross_margin) kpi.push(`Marge brute: ${o.gross_margin}%`);
  if (o.avg_basket) kpi.push(`Panier moyen: ${o.avg_basket}€`);
  if (o.monthly_customers) kpi.push(`Clients/mois: ${o.monthly_customers}`);
  if (o.revenue_trend) kpi.push(`Évolution CA: ${o.revenue_trend}%`);
  if (kpi.length) parts.push(`Indicateurs commerciaux: ${kpi.join(", ")}`);

  return parts.join(" · ");
}
